import moment from 'jalali-moment'

export const getThisWeek = () => {
    const week: Array<{ name: string; day: string }> = []
    Array.from(Array(5).keys()).map((idx) => {
        const dayNumber = moment()
            .locale('fa')
            .subtract(idx, 'days')
            .format('D')
        const dayName = moment()
            .locale('fa')
            .subtract(idx, 'days')
            .format('dddd')
        week.push({ day: dayNumber, name: dayName })
    })
    return week
}
